export const flowPath = '/applications/:applicationId/cancellation';
export const successPath = 'success';
